const status_data = {
    "pending" : "PENDING",
    "accepted" : "ACCEPTED",
    "rejected" : "REJECTED",
};

const type_data = {
    "store_details": "Store Details",
    "bank_details": "Bank Details",
    "tax_details": "Tax Details",
};

/* Store Data */
const store_fields_data = {
    "name": "Store Name",
	"email": "Email Address",
	"address": "Address",
	"state": "State",
	"city": "City",
	"pin_code": "Pincode",
	"phone_number": "Mobile Number",
	"alternate_phone_number": "Alternate Mobile Number",
};

/* Bank Data */
const bank_fields_data = {
    "account_type": "Account Type",
    "account_number": "Account Number",
    "phone_number": "Mobile Number",
    "ifsc_code": "IFSC Code",
    "account_holder_name": "Account Holder Name",
    "branch_name": "Branch Name",
    "branch_location": "Branch Location",
};

/* Tax Data */
const tax_fields_data = {
    "gst_number": "GST Number",
    "gst_trade_name": "GST Trade Name",
    "gst_legal_name": "GST Legal Name",
    "gst_registration_status": "GST Registration Status",
    "pan_number": "PAN Number",
    "pan_holder_name": "PAN Holder Name", 
};


const image_type = {
    "address_proof_images_data": "Address Proof Images",
    "dealer_board_images_data": "Dealer Board Images",
    "upload_bank_proof_images_data": "Bank Proof Images",
    "upload_ownership_proof_images_data": "Ownership Proof Images",
    "gst_certificate_proof_images_data": "GST Certificate Images",
    "pan_certificate_proof_images_data": "PAN Certificate Images"
};

export { 
    status_data, type_data, store_fields_data, bank_fields_data, tax_fields_data, image_type
};
